/**
 * Утилиты для работы с робоэдвайзером
 */

/**
 * Получает читаемое название типа клиента робоэдвайзера
 * @param type - тип клиента (например, 'TInvest')
 * @returns читаемое название типа с префиксом "Робоэдвайзер"
 */
export const getClientTypeName = (type?: string): string => {
  if (!type) return 'Робоэдвайзер';

  let typeName: string;
  switch (type) {
    case 'TInvest':
      typeName = 'Т-Инвестиции';
      break;
    case 'Bcs':
      typeName = 'BCS';
      break;
    default:
      typeName = type;
  }

  return `Робоэдвайзер ${typeName}`;
};
